<template>
  <el-dialog
    title="卡号明细"
    :visible.sync="isShow"
    width="700px"
    @close="closeDialog"
  >
    <el-table v-loading="isLoading" :data="tableList" border>
      <el-table-column type="index" width="70" label="序号" />
      <el-table-column prop="createTime" label="出货日期" align="left" />
      <el-table-column prop="categoryName" label="产品名称" align="left" />
      <el-table-column prop="cardNumber" label="卡号" align="left" />
    </el-table>

    <div style="text-align: right; margin-top: 10px">
      <el-pagination
        :page-sizes="[10, 20, 30, 40]"
        :page-size.sync="page.pageSize"
        :current-page.sync="page.currentPage"
        layout="total, prev, pager, next, jumper,sizes"
        :total="page.total"
        hide-on-single-page
        @size-change="handerSizeChange"
        @current-change="handerCurrentChange"
      />
    </div>
  </el-dialog>
</template>
<script type="es6">
import { queryCardNumberInformation } from '@/API';
export default {
  data () {
    return {
      isShow: false,
      isLoading: false,
      obj: {},
      tableList: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      }
    };
  },
  methods: {
    openDialog (invoiceNumber, strContractCode, rowData) {
      this.obj = { invoiceNumber, strContractCode, salesProductName: rowData.salesProductName };
      this.isShow = true;
      this.isLoading = true;
      this.queryList();
    },

    closeDialog () {
      this.obj = {};
      this.tableList = [];
      this.isShow = false;
    },

    queryList () {
      let params = {
        invoiceNo: this.obj.invoiceNumber,
        contractNo: this.obj.strContractCode,
        pageNo: this.page.currentPage,
        pageSize: this.page.pageSize,
        param: {
          condition: [{
            condition: true,
            operator: 'EQ',
            column: 'categoryName',
            value: [this.obj.salesProductName]
          }]
        }
      };
      queryCardNumberInformation(params).then((res) => {
        let json = res.data;
        this.isLoading = false;
        if (json.status === '200') {
          this.tableList = json.data.list;
          this.page.currentPage = json.data.pageNum;
          this.page.total = json.data.total;
        }
      }).catch(() => {
        this.isLoading = false;
      });
    },

    handerSizeChange () {
      this.page.currentPage = 1;
      this.queryList();
    },

    handerCurrentChange () {
      this.queryList();
    }
  }
};
</script>
